import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FiMail, FiLock, FiUser, FiPhone, FiEye, FiEyeOff, FiCheckCircle } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { GoogleLogin } from '@react-oauth/google';
import API from '../utils/api';
const AuthLayout = ({ children, title, subtitle }) => (
  <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',padding:'80px 16px 40px',background:'var(--bg-soft)',boxSizing:'border-box',overflowX:'hidden'}}>
        <div style={{width:'100%',maxWidth:440,boxSizing:'border-box'}}>      <div style={{textAlign:'center',marginBottom:32}}>
        <Link to="/" style={{display:'inline-flex',alignItems:'center',gap:10,fontFamily:'var(--font-display)',fontWeight:800,fontSize:'1.4rem',color:'var(--secondary)',marginBottom:24}}>
          {/* <span style={{width:36,height:36,background:'var(--primary)',color:'#fff',borderRadius:8,display:'flex',alignItems:'center',justifyContent:'center',fontWeight:900}}>P</span>
          Angel<span style={{color:'var(--primary)'}}>Printers</span> */}
          {/* <img src="/logo.svg" alt="Angel Printers" style={{height:46, width:'auto'}} /> */}
        </Link>
        <h1 style={{fontSize:'1.8rem',fontWeight:800,marginBottom:8}}>{title}</h1>
        <p style={{color:'var(--text-muted)'}}>{subtitle}</p>
      </div>
      <div style={{background:'#fff',borderRadius:'var(--radius-lg)',border:'1px solid var(--border)',padding:36,boxShadow:'var(--shadow-md)'}}>
        {children}
      </div>
    </div>
  </div>
);

export const GooglePhonePage = () => {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('phone'); // 'phone' -> 'otp'
  const [sending, setSending] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const { user, updateUser } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    if (!/^[6-9]\d{9}$/.test(phone)) {
      return toast.error('Enter a valid 10-digit phone number');
    }
    setSending(true);
    try {
      await API.post('/auth/send-otp', { phone });
      toast.success('Verification code sent on WhatsApp.');
      setStep('otp');
      setCooldown(30);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send code.');
    } finally {
      setSending(false);
    }
  };

  const handleResend = async () => {
    if (cooldown > 0) return;
    setSending(true);
    try {
      await API.post('/auth/send-otp', { phone });
      toast.success('Code resent on WhatsApp.');
      setCooldown(30);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to resend code.');
    } finally {
      setSending(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(code)) {
      return toast.error('Enter the 6-digit code.');
    }
    setVerifying(true);
    try {
      await API.post('/auth/verify-otp', { phone, code });
      const { data } = await API.put('/auth/profile', {
        name: user.name,
        phone,
      });
      updateUser(data.user);
      toast.success('Phone number verified!');
      navigate('/', { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Invalid or expired code.');
    } finally {
      setVerifying(false);
    }
  };

  if (step === 'otp') {
    return (
      <AuthLayout title="Verify your phone" subtitle={`We sent a 6-digit code on WhatsApp to +91 ${phone}`}>
        <form onSubmit={handleVerify}>
          <div className="form-group">
            <label>Verification Code</label>
            <input
              className="form-control"
              type="tel"
              value={code}
              onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
              placeholder="6-digit code"
              maxLength={6}
              autoFocus
              required
            />
          </div>
          <button type="submit" className="btn btn-primary" style={{width:'100%',justifyContent:'center',marginTop:8,padding:'13px'}} disabled={verifying}>
            {verifying ? 'Verifying...' : 'Verify & Continue'}
          </button>
        </form>
        <div style={{display:'flex',justifyContent:'space-between',marginTop:16,fontSize:'0.85rem'}}>
          <button type="button" onClick={() => setStep('phone')} style={{color:'var(--text-muted)',background:'none',border:'none',cursor:'pointer'}}>
            ← Change number
          </button>
          <button type="button" onClick={handleResend} disabled={cooldown > 0 || sending} style={{color: cooldown > 0 ? 'var(--text-muted)' : 'var(--primary)',fontWeight:600,background:'none',border:'none',cursor: cooldown > 0 ? 'default' : 'pointer'}}>
            {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend code'}
          </button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="One last step" subtitle="Please verify your phone number to complete signup">
      <form onSubmit={handleSendCode}>
        <div className="form-group">
          <label>Phone Number</label>
          <div style={{position:'relative'}}>
            <FiPhone size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
            <input
              className="form-control"
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value.replace(/\D/g, ''))}
              placeholder="9999999999"
              style={{paddingLeft:40}}
              maxLength={10}
              required
            />
          </div>
        </div>
        <button type="submit" className="btn btn-primary" style={{width:'100%',justifyContent:'center',marginTop:8,padding:'13px'}} disabled={sending}>
          {sending ? 'Sending...' : 'Send Code on WhatsApp'}
        </button>
      </form>
    </AuthLayout>
  );
};

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const { login, loading, googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const loggedInUser = await login(email, password);
     if (loggedInUser.role === 'admin' || loggedInUser.role === 'staff') {
       navigate('/admin', { replace: true });
     } else {
       navigate(from, { replace: true });
     }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed.');
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to your Angel Printers account">
      <div style={{display:'flex',justifyContent:'center',marginBottom:4}}>
        <GoogleLogin
          onSuccess={async (credentialResponse) => {
            try {
              const { user: loggedUser, isNew } = await googleLogin(credentialResponse);
              if (isNew) {
                navigate('/google-phone', { replace: true });
              } else if (loggedUser.role === 'admin' || loggedUser.role === 'staff') {
                navigate('/admin', { replace: true });
              } else {
                navigate(from, { replace: true });
              }
            } catch (err) {
              toast.error(err.response?.data?.message || 'Google login failed.');
            }
          }}
          onError={() => toast.error('Google login failed.')}
          width="100%"
        />
      </div>
      <div style={{margin:'20px 0',display:'flex',alignItems:'center',gap:10}}>
        <div style={{flex:1,height:1,background:'var(--border)'}}/> 
        <span style={{fontSize:'0.82rem',color:'var(--text-muted)'}}>or sign in with email</span>
        <div style={{flex:1,height:1,background:'var(--border)'}}/>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email Address</label>
          <div style={{position:'relative'}}>
            <FiMail size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
            <input className="form-control" type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" style={{paddingLeft:40}} required/>
          </div>
        </div>
        <div className="form-group">
          <label>Password</label>
          <div style={{position:'relative'}}>
            <FiLock size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
            <input className="form-control" type={showPw?'text':'password'} value={password} onChange={e=>setPassword(e.target.value)} placeholder="Enter your password" style={{paddingLeft:40,paddingRight:44}} required/>
            <button type="button" onClick={()=>setShowPw(v=>!v)} style={{position:'absolute',right:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)',display:'flex'}}>
              {showPw?<FiEyeOff size={16}/>:<FiEye size={16}/>}
            </button>
          </div>
        </div>
        <div style={{textAlign:'right',marginTop:-8,marginBottom:12}}>
          <Link to="/forgot-password" style={{fontSize:'0.82rem',color:'var(--primary)',fontWeight:600}}>Forgot password?</Link>
        </div>
        <p style={{fontSize:'0.8rem',color:'var(--text-muted)',textAlign:'center',marginBottom:14}}>
          By signing in, you agree to our{' '}
          <Link to="/terms" style={{color:'var(--primary)',fontWeight:600}}>Terms & Conditions</Link>{' '}
          and{' '}
          <Link to="/privacy" style={{color:'var(--primary)',fontWeight:600}}>Privacy Policy</Link>.
        </p>
        <button type="submit" className="btn btn-primary" style={{width:'100%',justifyContent:'center',marginTop:8,padding:'13px'}} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
      <p style={{textAlign:'center',marginTop:20,fontSize:'0.88rem',color:'var(--text-muted)'}}>
        Don't have an account? <Link to="/register" style={{color:'var(--primary)',fontWeight:600}}>Sign Up</Link>
      </p>
    </AuthLayout>
  );
};

export const RegisterPage = () => {
  const [form, setForm] = useState({name:'',email:'',password:'',phone:''});
  const [showPw, setShowPw] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [code, setCode] = useState('');
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const { register, loading, googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
const from = location.state?.from?.pathname || '/';
  const handleChange = e => setForm(f=>({...f,[e.target.name]:e.target.value}));

  React.useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setForm(fm => ({ ...fm, phone: value }));
    // If they edit the number after verifying, they need to verify again
    setPhoneVerified(false);
    setOtpSent(false);
    setCode('');
  };

  const handleSendOtp = async () => {
    if (!/^[6-9]\d{9}$/.test(form.phone)) {
      return toast.error('Enter a valid 10-digit phone number');
    }
    setSendingOtp(true);
    try {
      await API.post('/auth/send-otp', { phone: form.phone });
      toast.success('Verification code sent on WhatsApp.');
      setOtpSent(true);
      setCooldown(30);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send code.');
    } finally {
      setSendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!/^\d{6}$/.test(code)) {
      return toast.error('Enter the 6-digit code.');
    }
    setVerifyingOtp(true);
    try {
      await API.post('/auth/verify-otp', { phone: form.phone, code });
      setPhoneVerified(true);
      toast.success('Phone number verified!');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Invalid or expired code.');
    } finally {
      setVerifyingOtp(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   if (form.password.length < 6) {
    return toast.error('Password must be at least 6 characters.');
  }

  if (!/^[6-9]\d{9}$/.test(form.phone)) {
    return toast.error('Enter a valid 10-digit phone number');
  }

  if (!phoneVerified) {
    return toast.error('Please verify your phone number first.');
  }

  try {
    await register(form.name, form.email, form.password, form.phone);
    navigate('/', { replace: true });
  } catch (err) {
    toast.error(err.response?.data?.message || 'Registration failed.');
  }
};

  return (
    <AuthLayout title="Create account" subtitle="Join Angel Printers and start printing today">
  <div style={{display:'flex',justifyContent:'center',marginBottom:4}}>
    <GoogleLogin
      onSuccess={async (credentialResponse) => {
        try {
          const { user: loggedUser, isNew } = await googleLogin(credentialResponse);
          if (isNew) {
            navigate('/google-phone', { replace: true });
          } else if (loggedUser.role === 'admin' || loggedUser.role === 'staff') {
            navigate('/admin', { replace: true });
          } else {
            navigate(from, { replace: true });
          }
        } catch (err) {
          toast.error(err.response?.data?.message || 'Google sign up failed.');
        }
      }}
      onError={() => toast.error('Google sign up failed.')}
      width="100%"
    />
  </div>
  <div style={{margin:'20px 0',display:'flex',alignItems:'center',gap:10}}>
    <div style={{flex:1,height:1,background:'var(--border)'}}/>
    <span style={{fontSize:'0.82rem',color:'var(--text-muted)'}}>or sign up with email</span>
    <div style={{flex:1,height:1,background:'var(--border)'}}/>
  </div>
  <form onSubmit={handleSubmit}>
        {[
          {icon:<FiUser/>,name:'name',label:'Full Name',type:'text',placeholder:'Angel Printers'},
          {icon:<FiMail/>,name:'email',label:'Email Address',type:'email',placeholder:'angelprinters@example.com'},
        ].map(f=>(
          <div className="form-group" key={f.name}>
            <label>{f.label}</label>
            <div style={{position:'relative'}}>
              <span style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)',display:'flex'}}>{f.icon}</span>
              <input className="form-control" type={f.type} name={f.name} value={form[f.name]} onChange={handleChange}
  placeholder={f.placeholder}
  style={{ paddingLeft: 40 }}
  required/>
            </div>
          </div>
        ))}

        <div className="form-group">
          <label>Phone Number {phoneVerified && <span style={{color:'var(--primary)',fontWeight:600}}>✓ Verified</span>}</label>
          <div style={{display:'flex',gap:8}}>
            <div style={{position:'relative',flex:1}}>
              <FiPhone size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
              <input
                className="form-control"
                type="tel"
                value={form.phone}
                onChange={handlePhoneChange}
                placeholder="9999999999"
                style={{paddingLeft:40}}
                maxLength={10}
                disabled={phoneVerified}
                required
              />
            </div>
            {!phoneVerified && (
              <button
                type="button"
                className="btn btn-primary"
                style={{whiteSpace:'nowrap',padding:'0 16px'}}
                onClick={handleSendOtp}
                disabled={sendingOtp || (otpSent && cooldown > 0)}
              >
                {sendingOtp ? 'Sending...' : otpSent ? (cooldown > 0 ? `Resend (${cooldown}s)` : 'Resend') : 'Send Code'}
              </button>
            )}
          </div>

          {otpSent && !phoneVerified && (
            <div style={{display:'flex',gap:8,marginTop:10}}>
              <input
                className="form-control"
                type="tel"
                value={code}
                onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
                placeholder="Enter 6-digit code"
                maxLength={6}
                style={{flex:1}}
              />
              <button
                type="button"
                className="btn btn-primary"
                style={{whiteSpace:'nowrap',padding:'0 16px'}}
                onClick={handleVerifyOtp}
                disabled={verifyingOtp}
              >
                {verifyingOtp ? 'Verifying...' : 'Verify'}
              </button>
            </div>
          )}
          {otpSent && !phoneVerified && (
            <p style={{fontSize:'0.8rem',color:'var(--text-muted)',marginTop:6}}>
              We sent a code on WhatsApp to +91 {form.phone}
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Password</label>
          <div style={{position:'relative'}}>
            <FiLock size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
            <input className="form-control" type={showPw?'text':'password'} name="password" value={form.password} onChange={handleChange} placeholder="Min. 6 characters" style={{paddingLeft:40,paddingRight:44}} required/>
            <button type="button" onClick={()=>setShowPw(v=>!v)} style={{position:'absolute',right:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)',display:'flex'}}>
              {showPw?<FiEyeOff size={16}/>:<FiEye size={16}/>}
            </button>
          </div>
        </div>
        <p style={{fontSize:'0.8rem',color:'var(--text-muted)',textAlign:'center',marginBottom:14}}>
  By creating an account, you agree to our{' '}
  <Link to="/terms" style={{color:'var(--primary)',fontWeight:600}}>Terms & Conditions</Link>{' '}
  and{' '}
  <Link to="/privacy" style={{color:'var(--primary)',fontWeight:600}}>Privacy Policy</Link>.
</p>
        <button type="submit" className="btn btn-primary" style={{width:'100%',justifyContent:'center',marginTop:8,padding:'13px'}} disabled={loading || !phoneVerified}>
          {loading ? 'Creating account...' : 'Create Account'}
        </button>
      </form>
      <p style={{textAlign:'center',marginTop:20,fontSize:'0.88rem',color:'var(--text-muted)'}}>
        Already have an account? <Link to="/login" style={{color:'var(--primary)',fontWeight:600}}>Sign in</Link>
      </p>
    </AuthLayout>
  );
};


// ─── Forgot Password Page ────────────────────────────────────────────────────
// Step 1: Enter phone  →  Step 2: Enter OTP  →  Step 3: New password  →  Done
export const ForgotPasswordPage = () => {
  const [step, setStep] = useState('phone'); // 'phone' | 'otp' | 'password' | 'done'
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  const navigate = useNavigate();

  // Countdown timer for resend
  React.useEffect(() => {
    if (cooldown <= 0) return;
    const t = setTimeout(() => setCooldown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  // ── Step 1: Send OTP ────────────────────────────────────────────────────────
  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (!/^[6-9]\d{9}$/.test(phone)) {
      return toast.error('Enter a valid 10-digit Indian phone number.');
    }
    setLoading(true);
    try {
      await API.post('/auth/forgot-password/send-otp', { phone });
      toast.success('Verification code sent on WhatsApp.');
      setStep('otp');
      setCooldown(30);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not send OTP. Try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (cooldown > 0) return;
    setLoading(true);
    try {
      await API.post('/auth/forgot-password/send-otp', { phone });
      toast.success('Code resent on WhatsApp.');
      setCooldown(30);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to resend.');
    } finally {
      setLoading(false);
    }
  };

  // ── Step 2: Verify OTP ──────────────────────────────────────────────────────
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(code)) {
      return toast.error('Enter the 6-digit code.');
    }
    setLoading(true);
    try {
      await API.post('/auth/verify-otp', { phone, code });
      setStep('password');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Invalid or expired code.');
    } finally {
      setLoading(false);
    }
  };

  // ── Step 3: Reset Password ──────────────────────────────────────────────────
  const handleReset = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) {
      return toast.error('Password must be at least 6 characters.');
    }
    if (newPassword !== confirmPassword) {
      return toast.error('Passwords do not match.');
    }
    setLoading(true);
    try {
      await API.post('/auth/forgot-password/reset', { phone, code, newPassword });
      toast.success('Password reset successfully!');
      setStep('done');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Reset failed. Please try again.');
      // If OTP was wrong/expired, go back to OTP step
      if (err.response?.status === 400) setStep('otp');
    } finally {
      setLoading(false);
    }
  };

  // ── Done screen ─────────────────────────────────────────────────────────────
  if (step === 'done') {
    return (
      <AuthLayout title="Password Reset!" subtitle="Your password has been updated successfully.">
        <div style={{textAlign:'center',padding:'16px 0'}}>
          <FiCheckCircle size={56} style={{color:'var(--primary)',marginBottom:20}} />
          <p style={{color:'var(--text-muted)',marginBottom:28}}>You can now sign in with your new password.</p>
          <button
            className="btn btn-primary"
            style={{width:'100%',justifyContent:'center',padding:'13px'}}
            onClick={() => navigate('/login', { replace: true })}
          >
            Go to Login
          </button>
        </div>
      </AuthLayout>
    );
  }

  // ── Step 3: New password form ───────────────────────────────────────────────
  if (step === 'password') {
    return (
      <AuthLayout title="Set new password" subtitle="Choose a strong password for your account.">
        <form onSubmit={handleReset}>
          <div className="form-group">
            <label>New Password</label>
            <div style={{position:'relative'}}>
              <FiLock size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
              <input
                className="form-control"
                type={showPw ? 'text' : 'password'}
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="Min. 6 characters"
                style={{paddingLeft:40,paddingRight:44}}
                required
              />
              <button type="button" onClick={() => setShowPw(v => !v)}
                style={{position:'absolute',right:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)',display:'flex'}}>
                {showPw ? <FiEyeOff size={16}/> : <FiEye size={16}/>}
              </button>
            </div>
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <div style={{position:'relative'}}>
              <FiLock size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
              <input
                className="form-control"
                type={showConfirm ? 'text' : 'password'}
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Re-enter your password"
                style={{paddingLeft:40,paddingRight:44}}
                required
              />
              <button type="button" onClick={() => setShowConfirm(v => !v)}
                style={{position:'absolute',right:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)',display:'flex'}}>
                {showConfirm ? <FiEyeOff size={16}/> : <FiEye size={16}/>}
              </button>
            </div>
          </div>
          <button type="submit" className="btn btn-primary"
            style={{width:'100%',justifyContent:'center',marginTop:8,padding:'13px'}} disabled={loading}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </AuthLayout>
    );
  }

  // ── Step 2: OTP form ────────────────────────────────────────────────────────
  if (step === 'otp') {
    return (
      <AuthLayout title="Enter OTP" subtitle={`We sent a 6-digit code on WhatsApp to +91 ${phone}`}>
        <form onSubmit={handleVerifyOtp}>
          <div className="form-group">
            <label>Verification Code</label>
            <input
              className="form-control"
              type="tel"
              value={code}
              onChange={e => setCode(e.target.value.replace(/\D/g, ''))}
              placeholder="6-digit code"
              maxLength={6}
              autoFocus
              required
              style={{textAlign:'center',letterSpacing:'0.3em',fontSize:'1.3rem'}}
            />
          </div>
          <button type="submit" className="btn btn-primary"
            style={{width:'100%',justifyContent:'center',marginTop:8,padding:'13px'}}>
            Verify Code
          </button>
        </form>
        <div style={{display:'flex',justifyContent:'space-between',marginTop:16,fontSize:'0.85rem'}}>
          <button type="button" onClick={() => { setStep('phone'); setCode(''); }}
            style={{color:'var(--text-muted)',background:'none',border:'none',cursor:'pointer'}}>
            ← Change number
          </button>
          <button type="button" onClick={handleResend} disabled={cooldown > 0 || loading}
            style={{color: cooldown > 0 ? 'var(--text-muted)' : 'var(--primary)',fontWeight:600,background:'none',border:'none',cursor: cooldown > 0 ? 'default' : 'pointer'}}>
            {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend code'}
          </button>
        </div>
      </AuthLayout>
    );
  }

  // ── Step 1: Phone number form ───────────────────────────────────────────────
  return (
    <AuthLayout title="Forgot password?" subtitle="Enter your registered phone number to receive an OTP on WhatsApp.">
      <form onSubmit={handleSendOtp}>
        <div className="form-group">
          <label>Registered Phone Number</label>
          <div style={{position:'relative'}}>
            <FiPhone size={16} style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-muted)'}}/>
            <input
              className="form-control"
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value.replace(/\D/g, ''))}
              placeholder="9999999999"
              style={{paddingLeft:40}}
              maxLength={10}
              autoFocus
              required
            />
          </div>
        </div>
        <button type="submit" className="btn btn-primary"
          style={{width:'100%',justifyContent:'center',marginTop:8,padding:'13px'}} disabled={loading}>
          {loading ? 'Sending...' : 'Send OTP on WhatsApp'}
        </button>
      </form>
      <p style={{textAlign:'center',marginTop:20,fontSize:'0.88rem',color:'var(--text-muted)'}}>
        Remember your password? <Link to="/login" style={{color:'var(--primary)',fontWeight:600}}>Sign in</Link>
      </p>
    </AuthLayout>
  );
};

export default LoginPage;